import { render, staticRenderFns } from "./ChapterStudioResource.vue?vue&type=template&id=12980b3e&scoped=true&"
import script from "./ChapterStudioResource.vue?vue&type=script&lang=js&"
export * from "./ChapterStudioResource.vue?vue&type=script&lang=js&"
import style0 from "./ChapterStudioResource.vue?vue&type=style&index=0&id=12980b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12980b3e",
  null
  
)

export default component.exports